import { createApp, defineAsyncComponent } from 'vue';

//pinia
import { createPinia } from 'pinia';
const pinia = createPinia();

//styles
import './assets/tailwind.css';

const APP = defineAsyncComponent(() => import('./App.vue'));

import registerComponents from './components/components.js';
import router from './router';

//modal
import { createVfm } from 'vue-final-modal';
import 'vue-final-modal/style.css';

import Toast, { POSITION, TYPE } from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

import { plugin as VueTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import { vMaska } from 'maska/vue';

import VueClipboard from 'vue3-clipboard';
import i18n from '@/plugins/i18n/index.ts';
import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-3';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
pinia.use(piniaPluginPersistedstate);
// import { vMaska } from "maska"
const app = createApp(APP);

app.use(router);
app.use(i18n);
app.use(pinia);
app.directive('maska', vMaska);

//old chat
const visibleTawk = import.meta.env.VITE_TAWK_VISIBLE;
if (visibleTawk === 'true') {
  app.use(TawkMessengerVue, {
    propertyId: import.meta.env.VITE_TAWK_PROPERTY_ID,
    widgetId: import.meta.env.VITE_TAWK_WIDGET_ID,
  });
}

app.use(Toast, {
  position: POSITION.BOTTOM_RIGHT,
  toastDefaults: {
    [TYPE.ERROR]: {
      timeout: 180000,
      // closeButton: true,
      closeOnClick: false,
      position: POSITION.TOP_RIGHT,
      // showCloseButtonOnHover: true
    },
    [TYPE.SUCCESS]: {
      timeout: 3000,
      hideProgressBar: false,
      position: POSITION.TOP_RIGHT,
    },
  },
});

//global modal
const vfm = createVfm();
app.use(vfm);

app.use(VueTippy);
app.use(VueClipboard);
// app.use(Maska)
app.directive('money', {
  updated(el, binding, vnode) {
    el.innerHTML = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
    }).format(binding.value);
  },
});
registerComponents(app);
app.mount('#app');
